import React, { useEffect, useMemo, useState } from 'react';
import { Box, Card, CardContent, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import Layout from '../components/Layout/Layout';
import VelocityDashboard from '../components/Sprint/VelocityDashboard';
import apiService from '../services/api';
import { Project } from '../types';
import { useAuth } from '../contexts/AuthContext';

const Velocity: React.FC = () => {
  const { user } = useAuth();
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProjectId, setSelectedProjectId] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const isAdminView = useMemo(() => user?.role && ['admin', 'super_manager'].includes(user.role), [user?.role]);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const list = isAdminView ? await apiService.getProjects() : await apiService.getUserProjects();
        setProjects(list || []);
        if (list && list.length > 0) {
          setSelectedProjectId(list[0].id);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [isAdminView]);

  if (loading) {
    return (
      <Layout>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 240 }}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h4" fontWeight={700}>Team Velocity</Typography>
          <FormControl size="small" sx={{ minWidth: 280 }}>
            <InputLabel>Project</InputLabel>
            <Select
              label="Project"
              value={selectedProjectId}
              onChange={(e) => setSelectedProjectId(e.target.value as string)}
            >
              {projects.map(p => (
                <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {selectedProjectId ? (
          <VelocityDashboard projectId={selectedProjectId} height={360} showControls={true} />
        ) : (
          <Card>
            <CardContent>
              <Typography color="text.secondary">No projects available.</Typography>
            </CardContent>
          </Card>
        )}
      </Box>
    </Layout>
  );
};

export default Velocity;


